import React from "react"
import styles from "./NewTable.module.scss"
import { Loader } from "@/js/modules/Loader/Loader"
import { NoData } from "@/js/modules/NoData/NoData"
import { useNavigate } from "react-router-dom"

export function NewTable(props) {
	const {
		headers,
		tableData = [],
		children,
		isLoading,
		overflow,
		remoteMehod,
		onRowClick,
		onCellClick,
	} = props

	const handleRowClick = row => {
		if (onRowClick) onRowClick(row)
	}

	const fields = headers.map(header => header.field)
	const navigate = useNavigate()

	const handleEditClick = row => {
		const cleanTradePoint = {
			id: row.id,
			name: row.name,
			address: row.address,
		}

		localStorage.setItem("editingTradePoint", JSON.stringify(cleanTradePoint))
		navigate("/feedback")
	}

	if (!tableData.length) {
		return <NoData />
	}

	return (
		<div style={{ overflow: overflow }}>
			{isLoading ? (
				<Loader />
			) : (
				<table className={styles.table}>
					<thead className={styles.thead}>
						<tr className={styles.tableHead}>
							{headers.map(header => (
								<th
									key={header.field}
									className={`${styles.headCell} ${styles.cell}`}
								>
									{header.title}
								</th>
							))}
							<th
								style={{ background: "#eceff4", width: "10px" }}
								className={`${styles.headCell} ${styles.cell}`}
							></th>
						</tr>
					</thead>
					<tbody>
						{!children && tableData.length
							? tableData.map((row, idx) => (
									<tr
										className={styles.row}
										key={idx}
										onClick={row.isNonClick ? null : handleRowClick(row)}
									>
										{fields.map((field, cellIdx) => {
											const header = headers.find(h => h.field === field)
											return (
												<td
													data-label={header?.title}
													className={styles.cell}
													key={cellIdx}
												>
													{row[field]}
												</td>
											)
										})}
										<td
											style={{ padding: "0", background: "#eceff4" }}
											className={styles.cell}
										>
											<button
												onClick={() => handleEditClick(row)}
												className={styles.editButton}
											>
												<svg
													width="28"
													height="28"
													viewBox="0 0 28 28"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<rect
														x="0.5"
														y="0.5"
														width="27"
														height="27"
														rx="13.5"
														fill="#B83436"
													/>
													<rect
														x="16.1397"
														y="6.63513"
														width="3.8188"
														height="2.96805"
														transform="rotate(30 16.1397 6.63513)"
														stroke="white"
														strokeWidth="0.84375"
													/>
													<path
														d="M17.9572 11.1237L13.2575 19.2638L9.83845 21.3674L9.95068 17.3547L14.6504 9.21454L17.9572 11.1237Z"
														stroke="white"
														strokeWidth="0.84375"
													/>
												</svg>
											</button>
										</td>
									</tr>
							  ))
							: { children }}
					</tbody>
				</table>
			)}
		</div>
	)
}
